// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as Recoil from "recoil";
import * as Core__Option from "@rescript/core/src/Core__Option.bs.js";
import * as RenderIf$OrcaPaymentPage from "./Components/RenderIf.bs.js";
import * as CardUtils$OrcaPaymentPage from "./CardUtils.bs.js";
import * as RecoilAtoms$OrcaPaymentPage from "./Utilities/RecoilAtoms.bs.js";
import * as PaymentUtils$OrcaPaymentPage from "./Utilities/PaymentUtils.bs.js";
import * as CardValidations$OrcaPaymentPage from "../shared-code/sdk-utils/validation/CardValidations.bs.js";

function CardSchemeComponent$CoBadgeCardSchemeDropDown(props) {
  var setCardBrand = props.setCardBrand;
  var loggerState = Recoil.useRecoilValue(RecoilAtoms$OrcaPaymentPage.loggerAtom);
  return React.createElement("select", {
              className: "w-4",
              onChange: (function (ev) {
                  var target = ev.target;
                  var value = target.value;
                  setCardBrand(function (param) {
                        return value;
                      });
                }),
              onClick: (function (param) {
                  loggerState.setLogInfo("CardSchemeMenu expanded", "CARD_SCHEME_SELECTION", undefined, undefined, undefined, undefined, undefined);
                })
            }, React.createElement("option", {
                  disabled: true
                }, "Select a card brand"), props.eligibleCardSchemes.map(function (item, i) {
                  return React.createElement("option", {
                              key: i.toString(),
                              value: item
                            }, item);
                }));
}

var CoBadgeCardSchemeDropDown = {
  make: CardSchemeComponent$CoBadgeCardSchemeDropDown
};

function CardSchemeComponent(props) {
  var isCoBadgedCardDetectedOnce = props.isCoBadgedCardDetectedOnce;
  var cardBrand = props.cardBrand;
  var paymentType = props.paymentType;
  var cardNumber = props.cardNumber;
  var cardType = React.useMemo((function () {
          return CardUtils$OrcaPaymentPage.getCardType(cardBrand);
        }), [cardBrand]);
  var animate = cardType === "NOTFOUND" ? "animate-slideLeft" : "animate-slideRight";
  var cardBrandIcon = React.useMemo((function () {
          return CardUtils$OrcaPaymentPage.getCardBrandIcon(cardType, paymentType);
        }), [cardBrand]);
  var paymentMethodListValue = Recoil.useRecoilValue(PaymentUtils$OrcaPaymentPage.paymentMethodListValue);
  var enabledCardSchemes = Core__Option.getOr(PaymentUtils$OrcaPaymentPage.getSupportedCardBrands(paymentMethodListValue), []);
  var matchedCardSchemes = CardValidations$OrcaPaymentPage.getAllMatchedCardSchemes(CardValidations$OrcaPaymentPage.clearSpaces(cardNumber));
  var eligibleCardSchemes = CardUtils$OrcaPaymentPage.getEligibleCoBadgedCardSchemes(matchedCardSchemes, enabledCardSchemes);
  var isCardCoBadged = eligibleCardSchemes.length > 1;
  var marginLeft = isCardCoBadged ? "-ml-2" : "";
  var loggerState = Recoil.useRecoilValue(RecoilAtoms$OrcaPaymentPage.loggerAtom);
  var match = Recoil.useRecoilValue(RecoilAtoms$OrcaPaymentPage.optionAtom);
  var cardBrandIconSetting = CardUtils$OrcaPaymentPage.getLayoutClass(match.layout).cardBrandIcon;
  var shouldShowCoBadgeCardSchemeDropDown = isCardCoBadged && CardValidations$OrcaPaymentPage.clearSpaces(cardNumber).length >= 16;
  var showCardBrandIcon = CardUtils$OrcaPaymentPage.getCardBrandIconVisibility(cardBrandIconSetting, cardType);
  React.useEffect((function () {
          if (shouldShowCoBadgeCardSchemeDropDown && !isCoBadgedCardDetectedOnce.current) {
            isCoBadgedCardDetectedOnce.current = true;
            loggerState.setLogInfo("Card detected as co-badged", "CARD_SCHEME_SELECTION", undefined, undefined, undefined, undefined, undefined);
          }
          
        }), [shouldShowCoBadgeCardSchemeDropDown]);
  return React.createElement("div", {
              className: animate + " flex items-center " + marginLeft + " hellow-rodl"
            }, React.createElement(RenderIf$OrcaPaymentPage.make, {
                  condition: showCardBrandIcon,
                  children: cardBrandIcon
                }), React.createElement(RenderIf$OrcaPaymentPage.make, {
                  condition: shouldShowCoBadgeCardSchemeDropDown,
                  children: React.createElement(CardSchemeComponent$CoBadgeCardSchemeDropDown, {
                        eligibleCardSchemes: eligibleCardSchemes,
                        setCardBrand: props.setCardBrand
                      })
                }));
}

var make = CardSchemeComponent;

export {
  CoBadgeCardSchemeDropDown ,
  make ,
}
/* react Not a pure module */
